import { render } from "./PalliativeHomeTransfer.vue?vue&type=template&id=0baa06da&scoped=true"
import script from "./PalliativeHomeTransfer.vue?vue&type=script&lang=js"
export * from "./PalliativeHomeTransfer.vue?vue&type=script&lang=js"

import "./PalliativeHomeTransfer.vue?vue&type=style&index=0&id=0baa06da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0baa06da"]])

export default __exports__